import {OnInit, Component } from '@angular/core';
import {UserService} from '../../services/user.service';
import {Login} from '../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {CookieService} from 'ng2-cookies';

@Component({
  host: {
    '(document:keydown)': 'keyDown($event)',
  },

  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css']
})

export class ResetComponent implements OnInit {
  public LOGO = require("../../../assets/donut.png");
  public hex = require("../../../assets/hex.jpg");
  public passwd: string;
  public password2: string;
  public passwordFail: boolean = false;
  theUser: string;
  searchText: string;



  constructor(private userSVC: UserService, private router: Router, private activatedRoute: ActivatedRoute, private loginInfo: Login, private _cookieService:CookieService){
    loginInfo = new Login();
  }

  ngOnInit() {
     this.theUser = this.userSVC.authUser.email;
     if (!this.theUser) {
       this.router.navigate(['']);
     }

    this.activatedRoute.queryParams.subscribe(params => {
        this.searchText = params['q'] || "";
      });
   }

  setCookie(key: string, value: string){
    return this._cookieService.set(key, value);
  }
  getCookie(key: string){
    return this._cookieService.get(key);
  }

  reset(){
    if (!this.passwd || !this.password2 || this.passwd.length < 6 || this.password2.length < 6)
    {
      this.passwordFail = true;
      alert("The length of the passwd should be atleast 6 chars");
      return;
    }

    if (this.passwd !== this.password2) {
      this.passwordFail = true;
      return;
    }
    this.passwordFail = false;
    this.loginInfo.email = this.userSVC.authUser.email;
    this.loginInfo.sessionId = this.getCookie("gwt");
    this.loginInfo.passwd = this.passwd;
    this.userSVC.reset(this.loginInfo);
    this.router.navigate(['/login']);
  }

  keyDown(event: any) {
    switch (event.keyCode) {
      case 13:
        this.reset()
        event.preventDefault();
        break;
    }
    return;
  }

  done() {
    this.router.navigate(['/admin/account'], { queryParams: { q : this.searchText}});
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/reset/reset.component.ts